﻿module.exports = {
    strategy: 'Percentage',
    payer: 'Company',
    rules: [
        {
            taxValue: 2.00,
            minApplyAmount: 0.00
        }
    ]
};